import Icon from '../components/Icon.vue'

Icon.register({
  copy: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M320 448v40c0 13.3-10.7 24-24 24h-272c-13.3 0-24-10.7-24-24v-368c0-13.3 10.7-24 24-24h72v296c0 30.9 25.1 56 56 56h168zM320 104c0 13.2 10.8 24 24 24h104v264c0 13.3-10.7 24-24 24h-272c-13.3 0-24-10.7-24-24v-368c0-13.3 10.7-24 24-24h168v104zM441 73c3.9 3.9 7 11.5 7 17v6.1h-96v-96h6.1c5.5 0 13.1 3.1 17 7z'
      }
    ]
  }
})
